/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_error_page_invalid_request_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invalid Request`)
};

const zh_hans1_error_page_invalid_request_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无效请求`)
};

const zh_hant1_error_page_invalid_request_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無效請求`)
};

const fr_error_page_invalid_request_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Requête invalide`)
};

const de_error_page_invalid_request_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ungültige Anfrage`)
};

const ja_error_page_invalid_request_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無効なリクエスト`)
};

const ko_error_page_invalid_request_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`잘못된 요청`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const error_page_invalid_request_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.error_page_invalid_request_title(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("error_page_invalid_request_title", locale)
	if (locale === "en") return en_error_page_invalid_request_title(inputs)
	if (locale === "zh-Hans") return zh_hans1_error_page_invalid_request_title(inputs)
	if (locale === "zh-Hant") return zh_hant1_error_page_invalid_request_title(inputs)
	if (locale === "fr") return fr_error_page_invalid_request_title(inputs)
	if (locale === "de") return de_error_page_invalid_request_title(inputs)
	if (locale === "ja") return ja_error_page_invalid_request_title(inputs)
	return ko_error_page_invalid_request_title(inputs)
};